<template>
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="bg-primary-light p-3 rounded-2 me-3">
              <vue-feather type="bar-chart-2" stroke="#652aa3" size="22"></vue-feather>
            </div>
            <div>
              <h2 class="page-title mb-0">Performance Analytics</h2>
              <p class="text-muted mb-0">Comprehensive performance insights and metrics</p>
            </div>
          </div>
          <div class="d-flex gap-2">
            <button class="btn btn-outline-dark" @click="goBack">
              <vue-feather type="arrow-left" size="16" class="me-1"></vue-feather>
              Back
            </button>
            <button class="btn btn-outline-primary" @click="showFilters = !showFilters">
              <vue-feather type="filter" size="16" class="me-1"></vue-feather>
              {{ showFilters ? 'Hide' : 'Show' }} Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filters Section -->
    <div v-if="showFilters" class="row mb-4">
      <div class="col-12">
        <Card cardClasses="border-0 shadow-sm">
          <div class="card-body">
            <h5 class="mb-3">Filters</h5>
            <div class="row g-3">
              <div class="col-md-3">
                <label class="form-label small">Review Cycle</label>
                <select v-model="filters.cycle_id" class="form-select form-select-sm">
                  <option value="">All Cycles</option>
                  <option v-for="cycle in reviewCycles" :key="cycle.id" :value="cycle.id">
                    {{ cycle.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Employee</label>
                <select v-model="filters.employee_id" class="form-select form-select-sm">
                  <option value="">All Employees</option>
                  <option v-for="emp in employees" :key="emp.id" :value="emp.id">
                    {{ emp.first_name }} {{ emp.last_name }} ({{ emp.employee_no }})
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Department</label>
                <select v-model="filters.department_id" class="form-select form-select-sm">
                  <option value="">All Departments</option>
                  <option v-for="dept in departments" :key="dept.id" :value="dept.id">
                    {{ dept.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Designation</label>
                <select v-model="filters.designation_id" class="form-select form-select-sm">
                  <option value="">All Designations</option>
                  <option v-for="des in designations" :key="des.id" :value="des.id">
                    {{ des.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Work Station</label>
                <select v-model="filters.work_station_id" class="form-select form-select-sm">
                  <option value="">All Stations</option>
                  <option v-for="ws in workStations" :key="ws.id" :value="ws.id">
                    {{ ws.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Status</label>
                <select v-model="filters.status" class="form-select form-select-sm">
                  <option value="">All Statuses</option>
                  <option value="draft">Draft</option>
                  <option value="self_review">Self Review</option>
                  <option value="manager_review">Manager Review</option>
                  <option value="completed">Completed</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Rating</label>
                <select v-model="filters.rating" class="form-select form-select-sm">
                  <option value="">All Ratings</option>
                  <option value="outstanding">Outstanding</option>
                  <option value="exceeds_expectations">Exceeds Expectations</option>
                  <option value="meets_expectations">Meets Expectations</option>
                  <option value="needs_improvement">Needs Improvement</option>
                  <option value="unsatisfactory">Unsatisfactory</option>
                </select>
              </div>
<!--              <div class="col-md-3">-->
<!--                <label class="form-label small">Terms of Service</label>-->
<!--                <select v-model="filters.tos" class="form-select form-select-sm">-->
<!--                  <option value="">All TOS</option>-->
<!--                  <option value="Permanent">Permanent</option>-->
<!--                  <option value="Contract">Contract</option>-->
<!--                  <option value="Consultant">Consultant</option>-->
<!--                </select>-->
<!--              </div>-->
              <div class="col-md-3">
                <label class="form-label small">Gender</label>
                <select v-model="filters.gender" class="form-select form-select-sm">
                  <option value="">All Genders</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label small">Min Score</label>
                <input v-model.number="filters.min_score" type="number" min="0" max="100" class="form-control form-control-sm" placeholder="0" />
              </div>
              <div class="col-md-3">
                <label class="form-label small">Max Score</label>
                <input v-model.number="filters.max_score" type="number" min="0" max="100" class="form-control form-control-sm" placeholder="100" />
              </div>
              <div class="col-md-3">
                <label class="form-label small">Start Date</label>
                <input v-model="filters.start_date" type="date" class="form-control form-control-sm" />
              </div>
              <div class="col-md-3">
                <label class="form-label small">End Date</label>
                <input v-model="filters.end_date" type="date" class="form-control form-control-sm" />
              </div>
            </div>
            <div class="d-flex justify-content-end gap-2 mt-3">
              <button class="btn btn-sm btn-outline-secondary" @click="resetFilters">
                <vue-feather type="x" size="14" class="me-1"></vue-feather>
                Reset
              </button>
              <button class="btn btn-sm btn-primary" @click="applyFilters">
                <vue-feather type="check" size="14" class="me-1"></vue-feather>
                Apply Filters
              </button>
            </div>
          </div>
        </Card>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="text-center py-5">
      <Spinner spinner-class="mb-1" />
    </div>

    <div v-else>
      <!-- Overview Metrics -->
      <div class="row mb-4">
        <div class="col-md-3 mb-3">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="text-muted small">Total Reviews</span>
                <vue-feather type="file-text" size="20" class="text-primary"></vue-feather>
              </div>
              <h2 class="mb-0">{{ overview.total_reviews || 0 }}</h2>
              <small class="text-muted">{{ overview.completed_reviews || 0 }} completed</small>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="text-muted small">Average Score</span>
                <vue-feather type="award" size="20" class="text-warning"></vue-feather>
              </div>
              <h2 class="mb-0">{{ scores.average_score || 0 }}%</h2>
              <small :class="trends.trend_direction === 'up' ? 'text-success' : trends.trend_direction === 'down' ? 'text-danger' : 'text-muted'">
                <vue-feather :type="getTrendIcon()" size="14"></vue-feather>
                {{ trends.trend_direction }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="text-muted small">Completion Rate</span>
                <vue-feather type="check-circle" size="20" class="text-success"></vue-feather>
              </div>
              <h2 class="mb-0">{{ overview.completion_rate || 0 }}%</h2>
              <div class="progress" style="height: 4px">
                <div class="progress-bar bg-success" :style="`width: ${overview.completion_rate || 0}%`"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <span class="text-muted small">Pending Reviews</span>
                <vue-feather type="clock" size="20" class="text-info"></vue-feather>
              </div>
              <h2 class="mb-0">{{ overview.pending_reviews || 0 }}</h2>
              <small class="text-muted">Awaiting action</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Score Statistics -->
      <div class="row mb-4">
        <div class="col-md-8 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white border-bottom">
              <h5 class="mb-0">Department Performance</h5>
            </div>
            <div class="card-body">
              <div v-if="byDepartment.length" class="table-responsive">
                <table class="table table-hover align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Department</th>
                      <th class="text-center">Count</th>
                      <th>Average Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="dept in byDepartment" :key="dept.department_id">
                      <td class="fw-semibold">{{ dept.department_name }}</td>
                      <td class="text-center">
                        <span class="badge bg-light text-dark">{{ dept.count }}</span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="progress flex-grow-1 me-2" style="height: 8px; max-width: 150px">
                            <div class="progress-bar" :class="getScoreBadge(dept.average_score)" :style="`width: ${dept.average_score || 0}%`"></div>
                          </div>
                          <span class="badge" :class="getScoreBadge(dept.average_score)">{{ Math.round(dept.average_score || 0) }}%</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center text-muted py-4">
                <vue-feather type="inbox" size="48" class="mb-2 opacity-50"></vue-feather>
                <p class="mb-0">No department data available</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white border-bottom">
              <h5 class="mb-0">Score Statistics</h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Highest Score</span>
                  <strong class="text-success">{{ scores.highest_score || 'N/A' }}%</strong>
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Lowest Score</span>
                  <strong class="text-danger">{{ scores.lowest_score || 'N/A' }}%</strong>
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Median Score</span>
                  <strong>{{ scores.median_score || 'N/A' }}%</strong>
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Std Deviation</span>
                  <strong>{{ scores.standard_deviation || 'N/A' }}</strong>
                </div>
              </div>
              <hr>
              <div class="mb-3">
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Org Average</span>
                  <strong class="text-primary">{{ comparisons.organization_average || 'N/A' }}%</strong>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-between mb-1">
                  <span class="small text-muted">Filtered Average</span>
                  <strong>{{ comparisons.filtered_average || 'N/A' }}%</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Rating Distribution & Demographics -->
      <div class="row mb-4">
        <div class="col-md-6 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white border-bottom">
              <h5 class="mb-0">Rating Distribution</h5>
            </div>
            <div class="card-body">
              <div v-if="Object.keys(ratingDistribution).length">
                <div v-for="(count, rating) in ratingDistribution" :key="rating" class="mb-3">
                  <div class="d-flex justify-content-between mb-1">
                    <span class="text-capitalize">{{ formatRating(rating) }}</span>
                    <strong>{{ count }}</strong>
                  </div>
                  <div class="progress" style="height: 8px">
                    <div class="progress-bar" :class="getRatingBadge(rating).replace('badge ', '')" :style="`width: ${(count / overview.total_reviews) * 100}%`"></div>
                  </div>
                </div>
              </div>
              <div v-else class="text-center text-muted py-4">
                <vue-feather type="bar-chart" size="48" class="mb-2 opacity-50"></vue-feather>
                <p class="mb-0">No ratings yet</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white border-bottom">
              <h5 class="mb-0">Demographics</h5>
            </div>
            <div class="card-body">
              <h6 class="small text-muted mb-2">By Gender</h6>
              <div v-if="byGender.length" class="mb-3">
                <div v-for="item in byGender" :key="item.gender" class="d-flex justify-content-between align-items-center mb-2">
                  <span>{{ item.gender }}</span>
                  <div>
                    <span class="badge bg-light text-dark me-2">{{ item.count }}</span>
                    <span class="badge bg-primary">{{ Math.round(item.average_score || 0) }}% avg</span>
                  </div>
                </div>
              </div>

              <h6 class="small text-muted mb-2 mt-3">By Terms of Service</h6>
              <div v-if="byTos.length">
                <div v-for="item in byTos" :key="item.tos" class="d-flex justify-content-between align-items-center mb-2">
                  <span>{{ item.tos }}</span>
                  <div>
                    <span class="badge bg-light text-dark me-2">{{ item.count }}</span>
                    <span class="badge bg-info">{{ Math.round(item.average_score || 0) }}% avg</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reviews Table -->
      <div class="row mb-4">
        <div class="col-12">
          <Card cardClasses="border-0 shadow-sm">
            <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
              <h5 class="mb-0">Reviews ({{ pagination.total }})</h5>
              <div>
                <span class="small text-muted">Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }}</span>
              </div>
            </div>
            <div class="card-body p-0">
              <div v-if="reviews.length" class="table-responsive">
                <table class="table table-hover align-middle mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Employee</th>
                      <th>Department</th>
                      <th>Designation</th>
                      <th>Cycle</th>
                      <th>Status</th>
                      <th>Score</th>
                      <th>Rating</th>
                      <th class="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="review in reviews" :key="review.id">
                      <td>
                        <div class="fw-semibold">{{ review.employee?.first_name }} {{ review.employee?.last_name }}</div>
                        <small class="text-muted">{{ review.employee?.employee_no }}</small>
                      </td>
                      <td>{{ review.employee?.department?.name || 'N/A' }}</td>
                      <td>{{ review.employee?.designation?.name || 'N/A' }}</td>
                      <td>
                        <div class="small">{{ review.review_cycle?.name }}</div>
                      </td>
                      <td>
                        <span :class="getStatusBadge(review.status)">{{ review.status }}</span>
                      </td>
                      <td>
                        <span v-if="review.overall_score" class="badge" :class="getScoreBadge(review.overall_score)">
                          {{ Math.round(review.overall_score) }}%
                        </span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <span v-if="review.rating" :class="getRatingBadge(review.rating)">
                          {{ formatRating(review.rating) }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td class="text-end">
                        <router-link :to="`/performance/review/${review.id}`" class="btn btn-sm btn-outline-info">
                          <vue-feather type="eye" size="14"></vue-feather>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center text-muted py-5">
                <vue-feather type="inbox" size="48" class="mb-2 opacity-50"></vue-feather>
                <p class="mb-0">No reviews found</p>
              </div>
            </div>

            <!-- Pagination -->
            <div v-if="pagination.lastPage > 1" class="card-footer bg-white border-top">
              <nav>
                <ul class="pagination pagination-sm justify-content-center mb-0">
                  <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
                    <button class="page-link" @click="changePage(pagination.currentPage - 1)" :disabled="pagination.currentPage === 1">
                      Previous
                    </button>
                  </li>
                  <li v-for="page in pagination.lastPage" :key="page" class="page-item" :class="{ active: pagination.currentPage === page }">
                    <button class="page-link" @click="changePage(page)">{{ page }}</button>
                  </li>
                  <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.lastPage }">
                    <button class="page-link" @click="changePage(pagination.currentPage + 1)" :disabled="pagination.currentPage === pagination.lastPage">
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from 'vue'
import {usePerformanceStore} from '@/stores/performance'
import {useRouter} from 'vue-router'
import departmentService from '@/api/departmentService'
import designationService from '@/api/designationService'
import stationService from '@/api/stationService'
import employeeService from '@/api/employeeService'
import performanceService from '@/api/performanceService'
import moment from 'moment'

const performance = usePerformanceStore()
const router = useRouter()

// Reactive state
const loading = ref(false)
const data = ref(null)
const showFilters = ref(false)

// Filter state
const filters = reactive({
  cycle_id: '',
  employee_id: '',
  department_id: '',
  designation_id: '',
  work_station_id: '',
  rating: '',
  min_score: '',
  max_score: '',
  status: '',
  tos: '',
  start_date: '',
  end_date: '',
  gender: '',
  per_page: 20,
  page: 1
})

// Dropdown options
const departments = ref([])
const designations = ref([])
const workStations = ref([])
const reviewCycles = ref([])
const employees = ref([])

// Computed values
const reviews = computed(() => data.value?.reviews?.data || [])
const pagination = computed(() => ({
  currentPage: data.value?.reviews?.current_page || 1,
  lastPage: data.value?.reviews?.last_page || 1,
  total: data.value?.reviews?.total || 0,
  perPage: data.value?.reviews?.per_page || 20,
  from: data.value?.reviews?.from || 0,
  to: data.value?.reviews?.to || 0
}))

const statistics = computed(() => data.value?.statistics || {})
const trends = computed(() => data.value?.trends || {})
const comparisons = computed(() => data.value?.comparisons || {})

const overview = computed(() => statistics.value?.overview || {})
const scores = computed(() => statistics.value?.scores || {})
const ratingDistribution = computed(() => statistics.value?.rating_distribution || {})
const byDepartment = computed(() => statistics.value?.by_department || [])
const byDesignation = computed(() => statistics.value?.by_designation || [])
const byTos = computed(() => statistics.value?.by_tos || [])
const byGender = computed(() => statistics.value?.by_gender || [])

// Methods
const fetchAnalytics = async () => {
  loading.value = true
  try {
    const params = Object.fromEntries(
        Object.entries(filters).filter(([_, v]) => v !== '' && v !== null)
    )
    data.value = await performance.fetchAnalytics(params)
  } catch (e) {
    console.error('[Analytics] failed to fetch analytics:', e)
  } finally {
    loading.value = false
  }
}

const resetFilters = () => {
  Object.keys(filters).forEach(key => {
    if (key === 'per_page') filters[key] = 20
    else if (key === 'page') filters[key] = 1
    else filters[key] = ''
  })
  fetchAnalytics()
}

const applyFilters = () => {
  filters.page = 1
  fetchAnalytics()
}

const changePage = (page) => {
  filters.page = page
  fetchAnalytics()
}

const formatDate = (date) => {
  if (!date) return 'N/A'
  return moment(date).format('MMM DD, YYYY')
}

const getStatusBadge = (status) => {
  const map = {
    pending: 'bg-secondary',
    self_review: 'bg-info',
    manager_review: 'bg-warning',
    completed: 'bg-success',
    draft: 'bg-light text-dark'
  }
  return `badge ${map[status] || 'bg-secondary'}`
}

const getRatingBadge = (rating) => {
  const map = {
    outstanding: 'bg-success',
    exceeds_expectations: 'bg-primary',
    exceeds: 'bg-primary',
    meets_expectations: 'bg-info',
    meets: 'bg-info',
    needs_improvement: 'bg-warning',
    unsatisfactory: 'bg-danger'
  }
  return `badge ${map[rating] || 'bg-secondary'}`
}

const formatRating = (rating) => {
  const map = {
    outstanding: 'Outstanding',
    exceeds_expectations: 'Exceeds Expectations',
    exceeds: 'Exceeds Expectations',
    meets_expectations: 'Meets Expectations',
    meets: 'Meets Expectations',
    needs_improvement: 'Needs Improvement',
    unsatisfactory: 'Unsatisfactory'
  }
  return map[rating] || rating
}

const getTrendIcon = () => {
  const direction = trends.value?.trend_direction
  if (direction === 'up') return 'trending-up'
  if (direction === 'down') return 'trending-down'
  return 'minus'
}

const getScoreBadge = (score) => {
  if (!score) return 'bg-secondary'
  if (score >= 90) return 'bg-success'
  if (score >= 75) return 'bg-primary'
  if (score >= 60) return 'bg-info'
  if (score >= 40) return 'bg-warning'
  return 'bg-danger'
}

const goBack = () => {
  router.go(-1)
}

// Fetch dropdown data
const fetchDropdownData = async () => {
  try {
    const [depts, desigs, stations, cycles, emps] = await Promise.all([
      departmentService.getDepartments(),
      designationService.getDesignations(),
      stationService.getStations(),
      performanceService.getReviewCycles(),
      employeeService.getEmployees()
    ])

    departments.value = depts || []
    designations.value = desigs || []
    workStations.value = stations || []
    reviewCycles.value = cycles?.data || cycles || []
    employees.value = emps || []
  } catch (e) {
    console.error('Failed to fetch dropdown data:', e)
  }
}

onMounted(async () => {
  await Promise.all([
    fetchAnalytics(),
    fetchDropdownData()
  ])
})
</script>

<style scoped>
.bg-primary-light {
  background-color: rgba(101, 42, 163, 0.08);
}

.page-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #2c3e50;
}

.opacity-50 {
  opacity: 0.5;
}
</style>
